import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiparisForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [musteriler, setMusteriler] = useState([]);
  const [formData, setFormData] = useState({
    musteri_id: '',
    siparis_no: '',
    tutar: 0,
    para_birimi: 'TL',
    siparis_tarihi: new Date().toISOString().split('T')[0], // Bugünün tarihi varsayılan
    sozlesme_tarihi: '',
    termin_tarihi: '',
    uretim_tarihi: '',
    sevkiyat_tarihi: '',
    teslim_tarihi: '',
    durum: 'Beklemede',
    notlar: '',
    dosyalar: [],
    sohbet: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMusteriler();
    if (isEdit) {
      fetchSiparis();
    } else {
      setLoading(false);
    }
  }, [id]);

  const fetchMusteriler = async () => {
    try {
      const response = await axios.get(`${API}/musteriler`);
      setMusteriler(response.data);
    } catch (error) {
      console.error('Müşteriler yüklenirken hata:', error);
    }
  };

  const fetchSiparis = async () => {
    try {
      const response = await axios.get(`${API}/siparisler/${id}`);
      const data = response.data;
      // Convert dates to input format
      ['siparis_tarihi', 'sozlesme_tarihi', 'termin_tarihi', 'uretim_tarihi', 'sevkiyat_tarihi', 'teslim_tarihi'].forEach(field => {
        if (data[field]) {
          data[field] = new Date(data[field]).toISOString().split('T')[0];
        }
      });
      setFormData(data);
    } catch (error) {
      console.error('Sipariş yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Zorunlu tarih kontrolü
    if (!formData.siparis_tarihi) {
      alert('Sipariş Tarihi zorunludur');
      return;
    }
    if (!formData.termin_tarihi) {
      alert('Termin Tarihi zorunludur');
      return;
    }
    
    try {
      const submitData = { ...formData };
      // Convert date strings to ISO (sadece dolu olanları)
      ['siparis_tarihi', 'sozlesme_tarihi', 'termin_tarihi', 'uretim_tarihi', 'sevkiyat_tarihi', 'teslim_tarihi'].forEach(field => {
        if (submitData[field]) {
          submitData[field] = submitData[field] + 'T12:00:00.000Z';
        } else {
          submitData[field] = null; // Boş tarihleri null yap
        }
      });
      
      if (isEdit) {
        await axios.put(`${API}/siparisler/${id}`, submitData);
      } else {
        await axios.post(`${API}/siparisler`, submitData);
      }
      navigate('/siparisler');
    } catch (error) {
      console.error('Sipariş kaydedilirken hata:', error);
      alert('Sipariş kaydedilemedi');
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'number' ? parseFloat(e.target.value) : e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  if (loading) {
    return <div className="loading" data-testid="loading">Yükleniyor...</div>;
  }

  return (
    <div data-testid="order-form-page">
      <div className="page-header">
        <h1 className="page-title">{isEdit ? 'Sipariş Düzenle' : 'Yeni Sipariş'}</h1>
        <p className="page-subtitle">Sipariş bilgilerini giriniz</p>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Temel Bilgiler</h3>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Müşteri *</label>
              <select
                name="musteri_id"
                className="form-select"
                value={formData.musteri_id}
                onChange={handleChange}
                required
                disabled={false}
                data-testid="order-customer"
              >
                <option value="">Müşteri seçiniz</option>
                {musteriler.map(m => (
                  <option key={m.id} value={m.id}>{m.ad}</option>
                ))}
              </select>
              {isEdit && <small style={{color: '#666', fontSize: '12px'}}>💡 Müşteri değiştirilebilir</small>}
            </div>
            <div className="form-group">
              <label className="form-label">Sipariş No *</label>
              <input
                type="text"
                name="siparis_no"
                className="form-input"
                value={formData.siparis_no}
                onChange={handleChange}
                required
                data-testid="order-number"
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Tutar *</label>
              <input
                type="number"
                name="tutar"
                className="form-input"
                value={formData.tutar}
                onChange={handleChange}
                step="0.01"
                required
                data-testid="order-amount"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Para Birimi</label>
              <select
                name="para_birimi"
                className="form-select"
                value={formData.para_birimi}
                onChange={handleChange}
                data-testid="order-currency"
              >
                <option value="TL">TL</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Durum</label>
            <select
              name="durum"
              className="form-select"
              value={formData.durum}
              onChange={handleChange}
              data-testid="order-status"
            >
              <option value="Beklemede">Beklemede</option>
              <option value="Üretimde">Üretimde</option>
              <option value="Boyamada">Boyamada</option>
              <option value="Montajda">Montajda</option>
              <option value="Teslim Edildi">Teslim Edildi</option>
            </select>
          </div>
        </div>

        <div className="card">
          <h3 style={{ marginTop: 0 }}>Tarihler</h3>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Sipariş Tarihi *</label>
              <input
                type="date"
                name="siparis_tarihi"
                className="form-input"
                value={formData.siparis_tarihi}
                onChange={handleChange}
                required
                data-testid="order-date"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Sözleşme Tarihi</label>
              <input
                type="date"
                name="sozlesme_tarihi"
                className="form-input"
                value={formData.sozlesme_tarihi}
                onChange={handleChange}
                data-testid="contract-date"
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Termin Tarihi *</label>
              <input
                type="date"
                name="termin_tarihi"
                className="form-input"
                value={formData.termin_tarihi}
                onChange={handleChange}
                required
                data-testid="deadline-date"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Üretim Tarihi</label>
              <input
                type="date"
                name="uretim_tarihi"
                className="form-input"
                value={formData.uretim_tarihi}
                onChange={handleChange}
                data-testid="production-date"
              />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Sevkiyat Tarihi</label>
              <input
                type="date"
                name="sevkiyat_tarihi"
                className="form-input"
                value={formData.sevkiyat_tarihi}
                onChange={handleChange}
                data-testid="shipment-date"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Teslim Tarihi</label>
              <input
                type="date"
                name="teslim_tarihi"
                className="form-input"
                value={formData.teslim_tarihi}
                onChange={handleChange}
                data-testid="delivery-date"
              />
            </div>
          </div>
        </div>

        <div className="card">
          <h3 style={{ marginTop: 0 }}>Notlar</h3>
          <div className="form-group">
            <textarea
              name="notlar"
              className="form-textarea"
              value={formData.notlar}
              onChange={handleChange}
              rows={5}
              placeholder="Sipariş notları..."
              data-testid="order-notes"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary" data-testid="submit-btn">
            {isEdit ? 'Güncelle' : 'Kaydet'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/siparisler')} data-testid="cancel-btn">
            İptal
          </button>
        </div>
      </form>
    </div>
  );
};

export default SiparisForm;
